module.exports = __webpack_public_path__ + "img/MACHO_13-24.d1910221.jpeg";